import { Cell, Grid } from 'bold-ui'
import { RadioGroupField, usePecField } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'
import { ChangeEvent } from 'react'
import { useForm } from 'react-final-form'
import { metaPath } from 'util/metaPath'

import { MamografiaPerguntaField, RequisicaoExameMamografiaFormValues } from '../model-mamografia'
import { MamografiaIndicacaoClinicaDiagnosticaFormSection } from './MamografiaIndicacaoClinicaDiagnostica'
import { MamografiaRastreamentoRadioGroupField } from './MamografiaRastreamentoRadioGroupField'
import { mamografiaDiagnosticaFields, tipoMamografiaOptions } from './model-indicacaoClinica'

const meta = metaPath<RequisicaoExameMamografiaFormValues>()

export function MamografiaIndicacaoClinicaModalStep() {
  const {
    input: { value: tipoMamografia },
  } = usePecField<RastreioCancerPerguntaOpcaoEnum>({
    name: MamografiaPerguntaField.tipoMamografia,
    subscription: { value: true },
  })

  const form = useForm()

  const isRastreamento = tipoMamografia === RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO
  const isDiagnostico = tipoMamografia === RastreioCancerPerguntaOpcaoEnum.DIAGNOSTICO

  const handleTipoMamografiaChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO) {
      mamografiaDiagnosticaFields.forEach((field) => form.change(field, null))
      form.change(meta.openedAccordions.absolutePath(), [])
    } else if (event.target.value === RastreioCancerPerguntaOpcaoEnum.DIAGNOSTICO) {
      form.change(MamografiaPerguntaField.mamografiaRastreamento, null)
    }
  }

  return (
    <Grid>
      <Cell size={12} data-testid='tipoMamografia'>
        <RadioGroupField
          name={MamografiaPerguntaField.tipoMamografia}
          label='Tipo de mamografia'
          options={tipoMamografiaOptions}
          onChange={handleTipoMamografiaChange}
          required
        />
      </Cell>
      {isRastreamento && (
        <Cell size={12} data-testid='mamografiaRastreamento'>
          <MamografiaRastreamentoRadioGroupField />
        </Cell>
      )}
      {isDiagnostico && <MamografiaIndicacaoClinicaDiagnosticaFormSection />}
    </Grid>
  )
}
